import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import {
  Center,
  Container,
  GlossierNavigationLogo,
  InteractiveBorder,
  InteractiveText,
  Media,
  Padding,
  Queue,
  scrollToRefObject,
  ShadowedBorder,
  Text,
} from '../../components';
import { useScroll } from './use-scroll';

const NavigationButtons = (props) => {
  let { references } = props || {};
  let {
    openRolesRef,
    coreValuesRef,
    coreValuesMissionRef,
    lifeAtGlossierRef,
    benefitsAndPerksRef,
    frequentlyAskedQuestionsRef,
  } = references || {};
  return (
    <>
      <Padding size={[3]}>
        <InteractiveText
          nowrap
          opacity={0.5}
          textType="primary5"
          onClick={() => {
            track('Nav Clicked', {
              link_cta: 'About Glossier',
            });
            scrollToRefObject(coreValuesMissionRef);
          }}
        >
          About Glossier
        </InteractiveText>
      </Padding>
      <Padding size={[3]}>
        <InteractiveText
          nowrap
          opacity={0.5}
          textType="primary5"
          onClick={() => {
            track('Nav Clicked', {
              link_cta: 'Core Values',
            });
            scrollToRefObject(coreValuesRef);
          }}
        >
          Our Values
        </InteractiveText>
      </Padding>
      <Padding size={[3]}>
        <InteractiveText
          nowrap
          opacity={0.5}
          textType="primary5"
          onClick={() => {
            track('Nav Clicked', {
              link_cta: 'Life At Glossier',
            });
            scrollToRefObject(lifeAtGlossierRef);
          }}
        >
          Life at Glossier
        </InteractiveText>
      </Padding>
      <Padding size={[3]}>
        <InteractiveText
          nowrap
          opacity={0.5}
          textType="primary5"
          onClick={() => {
            track('Nav Clicked', {
              link_cta: 'Benefits And Perks',
            });
            scrollToRefObject(benefitsAndPerksRef);
          }}
        >
          Benefits and Perks
        </InteractiveText>
      </Padding>
      <Padding size={[3]}>
        <InteractiveText
          nowrap
          opacity={0.5}
          textType="primary5"
          onClick={() => {
            track('Nav Clicked', {
              link_cta: 'FAQ',
            });
            scrollToRefObject(frequentlyAskedQuestionsRef);
          }}
        >
          FAQs
        </InteractiveText>
      </Padding>
      <Padding size={[3]}>
        <InteractiveBorder
          opacity={0.5}
          borderSize={[2]}
          backgroundRole="black"
          radius="xLarge"
        >
          <Padding
            size={[0.5, 4]}
            onClick={() => {
              track('Nav Clicked', {
                link_cta: 'Open Roles',
              });
              scrollToRefObject(openRolesRef);
            }}
          >
            <Text nowrap textRole="secondary">
              Learn More
            </Text>
          </Padding>
        </InteractiveBorder>
      </Padding>
    </>
  );
};

const NavigationButtonsWrapper = styled.div`
  display: flex;
  padding: 0px;
  width: 100%;
  z-index: 200;
  overflow-x: scroll;
  text-align: center;
`;

const NavigationTransformer = styled.nav<any>`
  transform: translateY(${({ scrolled }) => scrolled && -100}%);
  transition: transform 380ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: -99;
  transition-delay: 0;
`;

const NavigationWrapper = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #fff;
  z-index: 100;
`;

const AbsoluteWrapper = styled.header`
  position: absolute;
  width: 100%;
`;

const RelativeWrapper = styled.div`
  position: relative;
  z-index: 99;
  width: 100%;
  background-color: #fff;
`;

export const Navigation = (props) => {
  const [scrolled, setScrolled] = useState(false);
  const { direction, y } = useScroll();

  useEffect(() => {
    setScrolled(direction === 'down' || undefined ? true : false);
  }, [direction]);

  return (
    <NavigationWrapper>
      <AbsoluteWrapper>
        <RelativeWrapper>
          <ShadowedBorder borderSize={[0, 0, 1, 0]} borderRole="grey3">
            <Padding size={[4, 0]}>
              <Center>
                <GlossierNavigationLogo
                  onClick={() =>
                    window.open('https://www.glossier.com', '_self')
                  }
                />
              </Center>
            </Padding>
          </ShadowedBorder>
        </RelativeWrapper>
        <NavigationTransformer scrolled={scrolled}>
          <RelativeWrapper>
            <Container>
              <Media at="sm">
                <NavigationButtonsWrapper>
                  <NavigationButtons {...props} />
                </NavigationButtonsWrapper>
              </Media>
              <Media at="md">
                <Center>
                  <Queue size={4}>
                    <NavigationButtons {...props} />
                  </Queue>
                </Center>
              </Media>
              <Media greaterThanOrEqual="xmd">
                <Center>
                  <Queue size={6} width="100%">
                    <NavigationButtons {...props} />
                  </Queue>
                </Center>
              </Media>
            </Container>
          </RelativeWrapper>
        </NavigationTransformer>
      </AbsoluteWrapper>
    </NavigationWrapper>
  );
};
